/*
  © 2025 LuminTheme
  https://www.lumintheme.com
*/

class LuminProductQtyBreak extends HTMLElement {
  constructor() {
    super();

    this.closest(".product")
      .querySelectorAll("lumin-product-qty-break")
      .forEach((elem, index) => {
        elem.setAttribute("data-index", index);
      });

    this.handleInputChange();
    this.handleOptionChange();
    this.handleAtc();
    this.handleVariantChange();
  }

  disconnectedCallback() {
    document.removeEventListener("variant:change", this._variantChangeHandler);
  }

  handleInputChange() {
    this.querySelector("input").addEventListener("change", () => {
      const atcBtn =
        this.closest(".product").querySelector('button[name="add"]');

      setTimeout(() => {
        atcBtn.classList.add("animate__animated", "animate__shakeX");
      }, 250);

      setTimeout(() => {
        atcBtn.classList.remove("animate__animated", "animate__shakeX");
      }, 1500);
    });
  }

  handleOptionChange() {
    this.querySelectorAll(".lumin-product-block-qty-break-variant select").forEach(
      (select) => {
        select.addEventListener("change", async () => {
          try {
            const response = await fetch(`${this.dataset.productUrl}.js`);
            if (!response.ok) throw new Error("Network response was not ok");
            const productData = await response.json();

            let totalPrice = 0;
            const discount = Number(this.dataset.discount);
            const discountType = this.dataset.discountType || "percentage";
            const qty = Number(this.dataset.qty) || 1;
            let selectedVariants = "";

            this.querySelectorAll(".lumin-product-block-qty-break-variant").forEach(
              (elem) => {
                const selectedOptions = [];

                elem.querySelectorAll("select").forEach((select) => {
                  selectedOptions.push(select.value);
                });

                const selectedVariant = productData.variants.find(
                  (variant) =>
                    JSON.stringify(variant.options) ===
                    JSON.stringify(selectedOptions)
                );

                if (!selectedVariant) {
                  throw new Error("Selected variant not found");
                }

                totalPrice += selectedVariant.price;
                selectedVariants += `${selectedVariant.id},`;
              }
            );

            // Calculate new values for placeholders
            let unitprice, discountq, savingAmount;
            let mainTotalCents;
            const fixedPrice = Number(this.dataset.fixedPrice) || 0;

            if (discountType === "percentage") {
              discountq = `${discount}%`;
              mainTotalCents = Math.round((totalPrice * (100 - discount)) / 100);
              const unitpriceFormatted = window.Shopify.formatMoney(
                Math.round(mainTotalCents / qty)
              );
              unitprice = this.extractTextFromMoney(unitpriceFormatted);

              const totalSavingCents = totalPrice - mainTotalCents;
              const savingAmountFormatted = window.Shopify.formatMoney(totalSavingCents);
              savingAmount = this.extractTextFromMoney(savingAmountFormatted);
            } else {
              const fixedPriceFormatted = window.Shopify.formatMoney(fixedPrice);
              discountq = this.extractTextFromMoney(fixedPriceFormatted);

              mainTotalCents = Math.max(totalPrice - fixedPrice, 0);
              const unitpriceFormatted = window.Shopify.formatMoney(
                Math.round(mainTotalCents / qty)
              );
              unitprice = this.extractTextFromMoney(unitpriceFormatted);

              const totalSavingCents = totalPrice - mainTotalCents;
              const savingAmountFormatted = window.Shopify.formatMoney(totalSavingCents);
              savingAmount = this.extractTextFromMoney(savingAmountFormatted);
            }

            const comparePriceType = this.dataset.comparePriceType || "calculated";
            const mainPriceHtml = window.Shopify.formatMoney(mainTotalCents).replace(".00", "");

            let compareHtml = "";
            if (comparePriceType === "original") {
              let totalCompareAt = 0;
              this.querySelectorAll(".lumin-product-block-qty-break-variant").forEach((elem) => {
                const selectedOptions = [];
                elem.querySelectorAll("select").forEach((select) => {
                  selectedOptions.push(select.value);
                });

                const selectedVariant = productData.variants.find(
                  (variant) =>
                    JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
                );

                if (selectedVariant && selectedVariant.compare_at_price) {
                  totalCompareAt += Number(selectedVariant.compare_at_price);
                }
              });

              if (totalCompareAt > mainTotalCents) {
                compareHtml = `<s>${window.Shopify.formatMoney(totalCompareAt).replace(".00", "")}</s>`;
              }
            } else {
              if (totalPrice > mainTotalCents) {
                compareHtml = `<s>${window.Shopify.formatMoney(totalPrice).replace(".00", "")}</s>`;
              }
            }

            this.querySelector(".lumin-product-block-qty-break-total").innerHTML =
              `${mainPriceHtml} ${compareHtml}`;

            // Update title/subtitle placeholders
            this.querySelectorAll(".lumin-product-block-qty-break-title").forEach((titleElem) => {
              let originalText = titleElem.getAttribute("data-original-text");
              if (!originalText) {
                originalText = titleElem.textContent;
                titleElem.setAttribute("data-original-text", originalText);
              }
              const updatedText = originalText
                .replace(/\[unit\]/g, unitprice)
                .replace(/\[\$\]/g, savingAmount)
                .replace(/\[%\]/g, discountq);
              titleElem.innerHTML = updatedText;
            });

            this.querySelectorAll(".lumin-product-block-qty-break-subtitle").forEach((subtitleElem) => {
              let originalText = subtitleElem.getAttribute("data-original-text");
              if (!originalText) {
                originalText = subtitleElem.textContent;
                subtitleElem.setAttribute("data-original-text", originalText);
              }
              const updatedText = originalText
                .replace(/\[unit\]/g, unitprice)
                .replace(/\[\$\]/g, savingAmount)
                .replace(/\[%\]/g, discountq);
              subtitleElem.innerHTML = updatedText;
            });

            this.querySelectorAll(".lumin-qty-bottom span").forEach((bottomTextElem) => {
              let originalText = bottomTextElem.getAttribute("data-original-text");
              if (!originalText) {
                originalText = bottomTextElem.textContent;
                bottomTextElem.setAttribute("data-original-text", originalText);
              }
              const updatedText = originalText
                .replace(/\[unit\]/g, unitprice)
                .replace(/\[\$\]/g, savingAmount)
                .replace(/\[%\]/g, discountq);
              bottomTextElem.innerHTML = updatedText;
            });

            this.querySelectorAll(".lumin-product-block-qty-break-extra-text").forEach((extraTextElem) => {
              let originalText = extraTextElem.getAttribute("data-original-text");
              if (!originalText) {
                originalText = extraTextElem.textContent;
                extraTextElem.setAttribute("data-original-text", originalText);
              }
              const updatedText = originalText
                .replace(/\[unit\]/g, unitprice)
                .replace(/\[\$\]/g, savingAmount)
                .replace(/\[%\]/g, discountq);
              extraTextElem.innerHTML = updatedText;
            });

            // ✅ IMPORTANT: keep input value updated for bundles with selects
            this.querySelector("input").value = selectedVariants.slice(0, -1);

            // Update auto-add product variant if configured
            const autoAddProductId = this.dataset.autoAddProduct;
            const autoAddVariantId = this.dataset.autoAddVariant;
            if (autoAddProductId && autoAddVariantId) {
              this.setAttribute("data-auto-add-variant", autoAddVariantId);
            }
          } catch (error) {
            console.error("Error updating product options:", error);
          }
        });
      }
    );
  }

  // ✅ FIX VERO: raggruppa IDs uguali in quantity (1 item con qty=N)
  handleAtc() {
    if (this.dataset.index !== "0") return;

    const atcBtn = this.closest(".product").querySelector('button[name="add"]');

    atcBtn.addEventListener("click", async (event) => {
      event.preventDefault();

      const checkedInput = this.closest(".product").querySelector(
        ".lumin-product-block-qty-break input:checked"
      );

      if (!checkedInput) {
        console.error("No variant selected");
        return;
      }

      // Lista tipo: "123,123,123,123" oppure "123,456"
      const raw = String(checkedInput.value || "").trim();
      if (!raw) {
        console.error("Selected bundle has empty variant list");
        return;
      }

      atcBtn.classList.add("loading");
      atcBtn.disabled = true;
      atcBtn.setAttribute("aria-busy", "true");
      atcBtn.querySelector(".loading__spinner").classList.remove("hidden");
      atcBtn.closest("product-form").handleErrorMessage();

      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      // 1) parse ids
      const ids = raw
        .split(",")
        .map((x) => String(x).trim())
        .filter(Boolean);

      // 2) group same ids => quantity
      const qtyMap = new Map();
      ids.forEach((id) => {
        qtyMap.set(id, (qtyMap.get(id) || 0) + 1);
      });

      const items = Array.from(qtyMap.entries()).map(([id, quantity]) => ({
        id,
        quantity,
      }));

      // 3) auto-add (se presente)
      const selectedQtyBreakBlock = checkedInput.closest("lumin-product-qty-break");
      if (selectedQtyBreakBlock) {
        const autoAddVariantId = selectedQtyBreakBlock.dataset.autoAddVariant;
        const autoAddQuantity = parseInt(selectedQtyBreakBlock.dataset.autoAddQuantity) || 1;

        if (autoAddVariantId) {
          items.push({
            id: String(autoAddVariantId).trim(),
            quantity: autoAddQuantity,
          });
        }
      }

      try {
        let sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items, sections }),
        });

        const responseData = await response.json();

        if (response.ok) {
          // Publish cart update event (tema/analytics)
          if (typeof publish !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "lumin-product-qty-break",
              productVariantId: String(items?.[0]?.id || ""),
              cartData: responseData,
            });
          }

          if (cart) {
            cart.renderContents(responseData);
            if (cart.classList.contains("is-empty")) {
              cart.classList.remove("is-empty");
            }
            if (cart.tagName.toLowerCase() === "cart-drawer") {
              cart.open();
            }
          } else {
            window.location.href = `${window.Shopify.routes.root}cart`;
          }
        } else {
          if (typeof publish !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "lumin-product-qty-break",
              productVariantId: String(items?.[0]?.id || ""),
              errors: responseData.errors || responseData.description,
              message: responseData.message,
            });
          }
          atcBtn.closest("product-form").handleErrorMessage(responseData.description);
        }
      } catch (error) {
        console.error("Error adding items to cart:", error);
        atcBtn.closest("product-form").handleErrorMessage(
          "Error adding items to cart. Please try again."
        );
      }

      atcBtn.style.width = "";
      atcBtn.classList.remove("loading");
      atcBtn.disabled = false;
      atcBtn.setAttribute("aria-busy", "false");
      atcBtn.querySelector(".loading__spinner").classList.add("hidden");
    });
  }

  extractTextFromMoney(moneyHtml) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = moneyHtml;
    let text = tempDiv.textContent || tempDiv.innerText || "";
    return text.replace(/\.00$/, "");
  }

  handleVariantChange() {
    if (this.dataset.index !== "0") return;

    const product = this.closest(".product");
    if (!product) return;

    const variantSelects = product.querySelector("variant-selects");
    if (!variantSelects) return;

    this._variantChangeHandler = async (event) => {
      if (this.dataset.index !== "0") return;

      try {
        const response = await fetch(window.location.href);
        if (!response.ok) throw new Error("Network response was not ok");
        const text = await response.text();
        const newDocument = new DOMParser().parseFromString(text, "text/html");

        product.querySelectorAll(".lumin-product-block-qty-break").forEach((elem) => {
          const newElement = newDocument.querySelector(
            `#lumin-product-block-qty-break-${elem.dataset.blockId}`
          );
          if (newElement) {
            elem.replaceWith(newElement);
          }
        });
      } catch (error) {
        console.error("Error updating quantity break blocks:", error);
      }
    };

    document.addEventListener("variant:change", this._variantChangeHandler);
  }
}

customElements.define("lumin-product-qty-break", LuminProductQtyBreak);
window.LuminProductQtyBreak = LuminProductQtyBreak;

class LuminCrossSells extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.addEventListener("change", () =>
        this.onCheckboxChange(checkbox)
      );
    });

    this.querySelectorAll('select[name="variant-id"]').forEach((select) => {
      select.addEventListener("change", () => this.onChangeVariant(select));
    });

    this.querySelectorAll("[data-cross-sells-footer] .button").forEach((btn) => {
      btn.addEventListener("click", () => this.addToCart(btn));
    });
  }

  onChangeVariant(select) {
    const variantImage = select[select.selectedIndex].dataset.variantImage;

    if (variantImage.length) {
      select
        .closest("[data-cross-sells-list-item]")
        .querySelector(".img-wrapper img")
        .setAttribute("src", variantImage);
    }

    this.updateTotalPrice();
  }

  onCheckboxChange(checkbox) {
    if (checkbox.checked) {
      checkbox
        .closest("[data-cross-sells-list-item]")
        .setAttribute("data-is-selected", "true");
    } else {
      checkbox
        .closest("[data-cross-sells-list-item]")
        .setAttribute("data-is-selected", "false");
    }
    this.updateTotalPrice();
  }

  updateTotalPrice() {
    let totalPrice = 0;
    let totalComparePrice = 0;

    this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      if (checkbox.checked) {
        const inputHidden = checkbox
          .closest("[data-cross-sells-list-item]")
          .querySelector('input[name="variant-id"][type="hidden"]');
        if (inputHidden) {
          totalPrice += Number(inputHidden.dataset.price);
          totalComparePrice += Number(inputHidden.dataset.compareAtPrice);
        }

        const select = checkbox
          .closest("[data-cross-sells-list-item]")
          .querySelector('select[name="variant-id"]');
        if (select) {
          totalPrice += Number(select[select.selectedIndex].dataset.price);
          totalComparePrice += Number(select[select.selectedIndex].dataset.compareAtPrice);
        }
      }
    });

    const stripHtml = (html) => {
      const tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    };

    this.querySelectorAll("[data-total-price]").forEach((elem) => {
      elem.textContent = stripHtml(window.Shopify.formatMoney(totalPrice)).replace(".00", "");
    });

    this.querySelectorAll("[data-total-compare-price]").forEach((elem) => {
      elem.textContent = stripHtml(window.Shopify.formatMoney(totalComparePrice)).replace(".00", "");
    });

    this.querySelectorAll("[data-total-savings]").forEach((elem) => {
      elem.textContent = stripHtml(
        window.Shopify.formatMoney(totalComparePrice - totalPrice)
      ).replace(".00", "");
    });

    this.querySelector("[data-cross-sells-footer] .button").disabled = totalPrice === 0;

    if (totalComparePrice > totalPrice) {
      this.querySelectorAll("[data-total-compare-price]").forEach((elem) => {
        elem.closest("s").removeAttribute("hidden");
      });
      this.querySelectorAll("[data-total-savings]").forEach((elem) => {
        elem.parentElement.removeAttribute("hidden");
      });
    } else {
      this.querySelectorAll("[data-total-compare-price]").forEach((elem) => {
        elem.closest("s").setAttribute("hidden", "hidden");
      });
      this.querySelectorAll("[data-total-savings]").forEach((elem) => {
        elem.parentElement.setAttribute("hidden", "hidden");
      });
    }
  }

  async addToCart(atcBtn) {
    atcBtn.classList.add("loading");
    atcBtn.disabled = true;
    atcBtn.setAttribute("aria-busy", "true");
    atcBtn.querySelector(".loading__spinner").classList.remove("hidden");

    const items = [];

    this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      if (checkbox.checked) {
        const id = Number(
          checkbox.closest("[data-cross-sells-list-item]").querySelector('[name="variant-id"]').value
        );
        items.push({ id, quantity: 1 });
      }
    });

    try {
      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      let sections = [];
      if (cart) {
        sections = cart.getSectionsToRender().map((section) => section.id);
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items, sections }),
      });

      if (!response.ok) throw new Error("Network response was not ok");
      const responseData = await response.json();

      if (cart) {
        cart.renderContents(responseData);
        if (cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
        if (cart.tagName.toLowerCase() === "cart-drawer") cart.open();
      } else {
        window.location.href = `${window.Shopify.routes.root}cart`;
      }
    } catch (error) {
      console.error("Error adding items to cart:", error);
      window.location.href = `${window.Shopify.routes.root}cart`;
    } finally {
      atcBtn.style.width = "";
      atcBtn.classList.remove("loading");
      atcBtn.disabled = false;
      atcBtn.setAttribute("aria-busy", "false");
      atcBtn.querySelector(".loading__spinner").classList.add("hidden");
    }
  }
}
customElements.define("lumin-cross-sells", LuminCrossSells);